import { Box, Tooltip } from '@mui/material'
import { StatusChip } from '../Details/features/status-chip'

export const renderStatusFilter = (val: string | boolean | string[]) => {
  if (Array.isArray(val)) {
    const isMore = val.length > 1

    const content = (
      <Box display="flex" gap={1} alignItems="center">
        {val.slice(0, 1).map((el, idx) => (
          <StatusChip key={`status-filter-${el}-${idx}`} status={Number(el)} />
        ))}
        {isMore && `+${val.length - 1}`}
      </Box>
    )

    return isMore ? (
      <Tooltip
        title={
          <Box display="flex" gap={1} alignItems="center" flexDirection="column">
            {val.slice(1).map((el, idx) => (
              <StatusChip key={`status-filter-${el}-${idx + 1}`} status={Number(el)} />
            ))}
          </Box>
        }
      >
        {content}
      </Tooltip>
    ) : (
      content
    )
  }
  return null
}
